import React from "react";
import { RootProps } from "./types";
import { RootElementContext } from "./context";

export const Root = ({ options, children }: RootProps) => (
  <RootElementContext.Provider value={{ ...options }}>
    {children}
  </RootElementContext.Provider>
);

// Export children
export { BaseMap } from "./BaseMap";
export { Marker } from "./Marker";
export { Popup } from "./Popup";
